import { createContext, useContext } from 'react';

const UserContext = createContext();
const Provider = UserContext.Provider;

function useUserContext() {
  return useContext(UserContext);
}

export {
  Provider,
  useUserContext
};
